import React, { useContext } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'
import { Redirect } from 'react-router-dom'
import { BillingSideMenu } from '../../components/Billing'
import { BaseLayout } from '../../layouts'
import { UserContext } from '../../providers'
import { BillingAlertsPage, BillingDetailsPage, SubscriptionsPage } from '.'
import CreditBalancePage from './CreditBalancePage'

const BillingRouter = (): React.ReactElement => {
  const { path } = useRouteMatch()
  const { user } = useContext(UserContext)

  return (
    <BaseLayout menu={<BillingSideMenu />}>
      <Switch>
        <Route path={`${path}`} exact>
          <Redirect to={`${path}/details`} />
        </Route>
        <Route exact path={`${path}/details`}>
          {user?.billingDetails.billTo === 'self' ? (
            <BillingDetailsPage />
          ) : (
            <Redirect to={`${path}/subscriptions`} />
          )}
        </Route>
        <Route exact path={`${path}/subscriptions`}>
          <SubscriptionsPage />
        </Route>
        <Route path={`${path}/alerts`} exact>
          {user?.billingDetails.billTo === 'self' ? (
            <BillingAlertsPage />
          ) : (
            <Redirect to={`${path}/subscriptions`} />
          )}
        </Route>
        <Route path={`${path}/credit-balance`} exact>
          {user?.billingDetails.billTo === 'self' ? (
            <CreditBalancePage />
          ) : (
            <Redirect to={`${path}/subscriptions`} />
          )}
        </Route>
      </Switch>
    </BaseLayout>
  )
}

export default BillingRouter
